// extracted by mini-css-extract-plugin
export default {"container":"TwoRadio_container__lh2T9","container__disabled":"TwoRadio_container__disabled__ga81y"};